import { LicenseInfo } from '@mui/x-license';

const MUI_PRO_LICENSE =
  '97e962c6e952835c508851239948ce0bTz0xMTk2NTYsRT0xNzkwODk5MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';

export const muiProLicenseInit = () => {
  return LicenseInfo.setLicenseKey(MUI_PRO_LICENSE);
};
